<template>
    <div class="dtablerow sell2 sellinone">


        <div id="right-panelx" class="right-panel fContainer">

            <SellHeader></SellHeader>

            <div class="content mt-3 fColumn">
                <div class="animated fadeIn fColumn">


                    <form action="/" method="post" id="form" class="userForm ajaxForm fColumn">

                        <div class="card fColumn fCard">
                            <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :msgPre="AlertInPage.msgPre" :msgPost="AlertInPage.msgPost" :delay="AlertInPage.delay"/>


                            <div class="card-header fHead">
                                <strong>{{$t('sell2.title')}}</strong>

                            </div>
                            <div class="card-body card-block fColumn pt-0 pb-0">

                                <div class="row ">
                                    <div class="col-4 scrollHeightEnable600x receiptDisplayContainer fContent pt-15 pb-15">


                                        <!--<BasketDisplayer :discount="buyer.discount" justDisplay="true"></BasketDisplayer>-->

                                        <table class="w100">

                                            <template v-for="(e, index) in purcaseItemsExtend">

                                                <template v-if="Number(e.pack) === Number(1)" class="table">
                                                    <tr>
                                                        <td class="">
                                                            <!--<span :for="'text-input' + e.itemKey " class="form-control-label">{{Helper.getValueByIdAndKeyFromObjectArray("name", elements, e.itemKey) }}</span>-->
                                                            <span :for="'text-input' + e.itemKey " class="form-control-label">{{e.name}}</span>
                                                        </td>
                                                        <td class="text-right align-top text-nowrap price pl-1" style="">
                                                            <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemCountnum}}</span>
                                                            x
                                                        </td>
                                                        <td class="text-right align-top text-nowrap price pr-1 pl-1" style="">
                                                            <small class="">{{prefix}}</small>
                                                            <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemPrice}}</span>
                                                            <small class="">{{suffix}}</small>
                                                        </td>
                                                        <td class="text-right align-top text-nowrap price" style="">
                                                            <small class="">{{prefix}}</small>
                                                            <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemSumPrice}}</span>
                                                            <small class="">{{suffix}}</small>
                                                        </td>
                                                        <!--<td class="icons">-->
                                                        <!--&lt;!&ndash;v-if="justDisplay=='false'"&ndash;&gt;-->
                                                        <!--<div class="input-group">-->
                                                        <!--<a class="btn_delrow input-group-addon " v-on:click="delrow(index)">-->
                                                        <!--<div class=" "><i class="fa fa-times"></i></div>-->
                                                        <!--</a>-->
                                                        <!--</div>-->
                                                        <!--</td>-->
                                                    </tr>


                                                </template>
                                                <template v-if="Number(e.pack) >= 2 && Number(e.pack) <= 7" class="table">

                                                    <tr>
                                                        <td class="">
                                                            <span :for="'text-input' + e.itemKey " class="form-control-label">{{e.name}}</span>
                                                        </td>
                                                        <td class="text-right align-top text-nowrap price pl-1" style="">
                                                            <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemValue}}</span>
                                                            <!--<span id="text-display' + e.itemKey + '" class="" data-id="' + e.itemKey + '">' + e.itemValue + '</span>-->

                                                            <small class="" v-if="e.pack==='2'"> {{$t('global.pc')}}</small>
                                                            <small class="" v-if="e.pack==='3'"> {{$t('global.kg')}}</small>
                                                            <small class="" v-if="e.pack==='4'"> {{$t('global.l')}}</small>
                                                            <small class="" v-if="e.pack==='5'"> {{$t('global.m')}}</small>
                                                            <small class="" v-if="e.pack==='6'"> {{$t('global.pack')}}</small>
                                                            <small class="" v-if="e.pack==='7'"> {{$t('global.occasion')}}</small>
                                                        <td class="text-right align-top text-nowrap price pr-1 pl-1" style="">
                                                            <small class="">{{prefix}}</small>
                                                            <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemPrice}}</span>
                                                            <small class="">{{suffix}}</small>
                                                        </td>
                                                        <td class="text-right align-top text-nowrap price" style="">
                                                            <small class="">{{prefix}}</small>
                                                            <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemSumPrice}}</span>
                                                            <small class="">{{suffix}}</small>
                                                        </td>
                                                    </tr>

                                                </template>


                                            </template>
                                        </table>

                                        <div v-if="Number(discount_price)>0&&discount_price>0">
                                            <table class="w100">
                                                <tr>
                                                    <td class=" extensionLine">
                                                        <span class="form-control-label">{{$t('global.discount')}}</span>
                                                    </td>
                                                    <td class=" text-right text-nowrap extensionLine">
                                                        <small class="">{{prefix}}</small>
                                                        <span id="Xdiscount_price" class="discount_price">{{discount_price}}</span>
                                                        <small class="">{{suffix}}</small>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <template v-if="Number(sum)>0">
                                            <table class="w100">
                                                <tr>
                                                    <td class="extensionLineX">
                                                        <span class="form-control-label">{{$t('global.sumPrice')}}</span>
                                                    </td>
                                                    <td class="text-right text-nowrap extensionLineX">
                                                        <small class="">{{prefix}}</small>
                                                        <span id="" class="sum">{{sum}}</span>
                                                        <small class="">{{suffix}}</small>
                                                    </td>
                                                </tr>
                                            </table>
                                        </template>


                                    </div>
                                    <div class="col-8 scrollHeightEnable600x fContent pt-15 pb-15">


                                        <div class="row form-group">
                                            <div class="col col-md-4 "><label for="selltext" class=" form-control-label">{{$t('sell2.buyer')}}</label>
                                            </div>
                                            <div class="col-12 col-md-12">
                                                <BuyerSearcher justDisplay="true"></BuyerSearcher>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col col-md-4 "><label for="selltext" class=" form-control-label">{{$t('sell2.businesspartner')}}</label>
                                            </div>
                                            <div class="col-12 col-md-12">
                                                <div class="input-group">

                                                    <!--<span  v-if="businesspartner.id" class="btn btn-success Xinput-group-addon float-right" v-on:click="$eventBus.$emit('globalChooseProductSearcher', {type:'BusinessPartnerSearcher'})">-->
                                                    <!--<i class="fa fa-briefcase"></i>-->
                                                    <!--</span>-->
                                                    <!--<span v-if="!businesspartner.id" class="btn btn-info Xinput-group-addon float-right" v-on:click="$eventBus.$emit('globalChooseProductSearcher', {type:'BusinessPartnerSearcher'})">-->
                                                    <!--<i class="fa fa-briefcase"></i>-->
                                                    <!--</span>-->
                                                    <InputText style="flex:1 1 0px" hasToKeyboard="false" id="x"
                                                               :value="(businesspartner.taxnumber || businesspartner.businesspartnername)?businesspartner.businesspartnername + ', ' + businesspartner.taxnumber:''"
                                                               title="" placeholder="" className="form-control w100 d-block" readonly/>
                                                    <!--<a style="flex: 0.01 1;" class="btn_del_input input-group-addon pointer" data-id="0" v-on:click="clickToClearBusinessPartner()">-->
                                                    <!--<div class=" "><i class="fa fa-times"></i></div>-->
                                                    <!--</a>-->
                                                    <template v-if="businesspartner.discount">
                                                        <div style="flex: 0.02 0 0;" class="input-group-addonX discount_type_container discount_type btn btn-danger ">{{businesspartner.discount}}<span
                                                                v-if="businesspartner.discount">%</span></div>
                                                    </template>
                                                    <template v-if="!businesspartner.discount">
                                                        <div style="flex: 0.02 0 0;" class="input-group-addon discount_type_container discount_type">{{businesspartner.discount}}<span
                                                                v-if="businesspartner.discount">%</span></div>
                                                    </template>

                                                    <!--{{businesspartner.businesspartnername}} {{businesspartner.taxnumber}}-->
                                                </div>

                                            </div>
                                        </div>

                                        <div class="hiddenSzb">
                                            <input type="text" name="del">
                                            <input type="text" id="id" name="id" class="form-control id" value="">
                                            <input type="text" id="id_buyer" v-model="data.id_buyer" class="form-control id_buyer" value="">
                                        </div>

                                        <!--<ProductTabs></ProductTabs>-->

                                        <hr>


                                        <div class="row form-group" v-if="hasselltext">
                                            <div class="col col-md-4 extensionLine"><label for="selltext" class=" form-control-label">{{$t('sell2.selltext')}}</label>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <InputText disabled readonly hasToKeyboard="auto" id="selltext" v-model="data.selltext" title="Megjegyzés" placeholder="" dataLayout="t" className="form-control"/>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col col-3 extensionLine">
                                                <label class=" form-control-label">{{$t('sell2.selltype')}}</label>
                                            </div>
                                            <div class="col col-3">
                                                <div class="">
                                                    <div class="radio">
                                                        <label for="radio1" class="btn btn-outline-secondary form-check-label form-control border-sel">
                                                            <input type="radio" id="radio1" value="1" v-model="data.selltype" checked class="form-check-input">{{$t('sell2.selltype1')}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col col-3">
                                                <div class="">
                                                    <div class="radio">
                                                        <label for="radio2" class="btn btn-outline-secondary form-check-label form-control border-sel">
                                                            <input type="radio" id="radio2" value="2" v-model="data.selltype" class=" form-check-input">{{$t('sell2.selltype2')}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col col-3">
                                                <div class="">
                                                    <div class="radio">
                                                        <label for="radio3" class="btn btn-outline-secondary form-check-label form-control border-sel">
                                                            <input type="radio" id="radio3" value="3" v-model="data.selltype" class=" form-check-input">{{$t('sell2.selltype3')}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row form-group discountpriceContainer">
                                            <div class="col col-7 extensionLine">
                                                <label class=" form-control-label">{{$t('sell2.discount')}}</label>
                                            </div>
                                            <div class="col col-5 text-right">

                                                <small class="">{{prefix}}</small>
                                                <label type="text" class="form-controlX discount_price">{{discount_price}}</label>
                                                <!--<input readonly type="text" id="discount_price" v-model="discountprice"  name="" placeholder="" class="d-none form-control">-->
                                                <small class="">{{suffix}}</small>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col col-7 extensionLine"><label for="sum" class=" form-control-label">{{$t('sell2.sum')}}</label></div>
                                            <div class="col col-5 text-right">
                                                <small class="">{{prefix}}</small>
                                                <label type="text" id="sum" class="form-controlX sum">{{sum}}</label>
                                                <!--<input type="text" id="textinputX" name="sum" v-model="sum" placeholder="" class="form-control d-none">-->
                                                <small class="">{{suffix}}</small>
                                            </div>
                                        </div>

                                        <!--</form>-->


                                    </div>

                                </div>
                            </div>

                            <div class="fFix card-footer text-center">

                                <button v-on:click="go_back()" type="button" class="mb-1 btn btn-success btn-lg btn-finish" v-if="!hassaved">
                                    <!--<i class="fa fa-arrow-circle-o-left"></i>-->
                                    <i class="fa fa-angle-double-left"></i>
                                    <!--<< -->
                                    {{$t('sell2.back')}}
                                </button>&nbsp;
                                <button v-on:click="do_finish()" type="button" class="mb-1 btn btn-info btn-lg btn-finish" v-if="printQuestionExit&&!hassaved">
                                    <i class="fa fa-dot-circle-o"></i> {{$t('sell2.finish')}}
                                </button>&nbsp;
                                <button v-on:click="do_print()" type="button" class="mb-1 btn btn-info btn-lg btn-save" v-if="printQuestionPrint">
                                    <i class="fa fa-print"></i> {{$t('sell2.print')}}
                                </button>&nbsp;
                                <!--<button v-on:click="do_deliverynote()" type="button" class="mb-1 btn btn-info btn-lg" :disabled="!hasdeliverynoteNextIdentifier" v-if="printQuestionDeliverynote&&!hassaved">-->
                                    <!--<i class="fa fa-document"></i> {{$t('sell2.deliverynote')}}-->
                                <!--</button>-->

                              <!--&& $route.params.data.id_businesspartner-->
                              <!--<template v-if="(invoiceUseType===3||invoiceUseType===2) && !$route.params.data.id_businesspartner">-->
                                <!--{{$t('sell2.needpartner')}}-->
                              <!--</template>-->

                              <template v-if="(invoiceUseType===3||invoiceUseType===2) ">
                                <button v-on:click="do_giveinvoice()" type="button" class="mb-1 btn btn-warning btn-lg btn-save" v-if="printQuestionInvoice">
                                  <template v-if="invoiceUseType===3">
                                    <i class="fa fa-document"></i> {{$t('sell2.giveinvoiceszamlazzhu')}}
                                  </template>
                                  <template v-if="invoiceUseType===2">
                                    <i class="fa fa-document"></i> {{$t('sell2.giveinvoice')}}
                                  </template>
                                </button>&nbsp;
                              </template>

                                <button v-on:click="do_newsell()" type="button" class="mb-1 btn btn-info btn-lg btn-save" v-if="printQuestionInvoice && hassaved">
                                    <i class="fa fa-shopping-cart"></i> {{$t('sell2.newSell')}}
                                </button>


                            </div>


                        </div>


                    </form>


                </div><!-- .animated -->
            </div><!-- .content -->


        </div>

        <!-- Right Panel -->
    </div>

</template>

<script>

    // @ is an alias to /src
    import SellHeader from '@/components/SellHeader.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Api from '@/api/Api';
    import Helper from '@/helper/Helper';
    import HelperSzamlazzhu from '@/helper/HelperSzamlazzhu';
    import InputText from '@/components/InputText.vue';
    import LinkToTemplate from "../components/LinkToTemplate";
    import BarcodeGenerator from '@/components/BarcodeGenerator.vue';
    import JsBarcode from 'jsbarcode';
//    import Sync from '@/components/Sync.vue';
    import BuyerSearcher from "../components/BuyerSearcher";
    import ProductSearcher from "../components/ProductSearcherMass";
    import BasketDisplayer from "../components/BasketDisplayer";
    import ProductTabs from "../components/ProductTabs";
    //    var electron = require('electron');
    //    const {ipcRenderer} = require('electron');
//    import SyncHandler from '@/sync/syncHandler';
//    const machineId = require('node-machine-id').machineId;
//    const machineIdSync = require('node-machine-id').machineIdSync;
//    const {ipcRenderer} = require('electron');

    const request = require('request');
    const https = require('https');
    import moment from 'moment';
    import {saveAs} from 'file-saver';
    //    const sqlite3 = require('sqlite3').verbose();

    export default {
        name: 'Sell2',
        data() {
            return {
                prefix: "",
                suffix: "",
                purcaseItems: [],
                purcaseItemsExtend: [],
                cachedElements: [],
                data: {
                    "id": "",
//                    "id_buyer": null,
                    "selltext": "",
                    "selltype": "1",
                },
                dataBase: {
                    "id": "",
                    "selltext": "",
                    "selltype": "1",
                },
                discount: 0,
                discount_price: 0,
                discount_percentage: 0,
                sum: 0,
                buyer: {},
                businesspartner: {},
//                discountBand: [],
                printQuestion: 3, // for modify the default value use the settings screen too
                printQuestionExit: true,
                printQuestionPrint: true,
                printQuestionDeliverynote: false,
                printQuestionInvoice: true,
                hasselltext: false,
                hasdeliverynoteNextIdentifier: false,
                AlertInPage: {
                    type: "", // primary secondary success danger warning info light dark
                    msg: "",
                    msgPre: "",
                    msgPost: "",
                    delay: 5000,
                },
                hassaved: false,
                choosedDiscount: null, // for back
                invoiceUseType: 2,
                invoice_process: false,

        };
        },
        props: {
            id: String,
        },
        watch: {
            discount: function (newData, oldData) {
                const modul = this;
                modul.makeBasketCalculation();
            },
            purcaseItems: function (newData, oldData) {
                const modul = this;
                const purcaseItemsExtend = [];
                Array.prototype.forEach.call(newData, function (e) {
                    const eCopied = Object.assign({}, e);
//                    purcaseItemsExtend.push(Object.assign(eCopied, modul.getElementByIdSync(e.itemKey)));
                  purcaseItemsExtend.push(Object.assign(eCopied, modul.getElementFromCachedElementsById(e.itemKey)));
                });
                this.purcaseItemsExtend = purcaseItemsExtend;
                modul.makeBasketCalculation();
            },
            buyer: function (newData, oldData) {
                const modul = this;
                modul.makeBasketCalculation();
            },
            businesspartner: function (newData, oldData) {
                const modul = this;
                modul.makeBasketCalculation();
            },
        },
        mounted() {
            const modul = this;
            console.log(this.$route.name + " mounded");
            modul.roles = [2, 3, 4, 5, 6, 7, 8, 9, 10];
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          if (!Helper.checkRoles(modul.roles, role)) {
                modul.$router.push({name: "login"})
            }
            try{
              modul.invoiceUseType = Helper.Number(localStorage.getItem("invoiceUseType"));
              localStorage.getItem("invoiceUseType");
            } catch (e){
              modul.invoiceUseType = "2";
              localStorage.setItem("invoiceUseType", modul.invoiceUseType);
            }
            modul.hassaved = false;
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();
            // Ezt kivesszük!
//            Helper.getDeliverynoteNextIdentifiers(function (err, res) {
//                if (res && res[0]) {
//                    modul.hasdeliverynoteNextIdentifier = true;
//                } else {
//                    modul.hasdeliverynoteNextIdentifier = false;
//
//                }
//            }, "deliverynote");
            if (modul.$route.params.data) {
                console.log("sellinone init as id: " + modul.$route.params.sellId);
                // TODO ide kell enek a lekérések, amik beolvassák az eladást!!


//                modul.$route.data
//                modul.$route.purcaseItems

                modul.data = modul.$route.params.data;
                modul.data.id = modul.$route.params.data.id;
                modul.data.selltext = modul.$route.params.data.selltext;
                modul.data.selltype = modul.$route.params.data.selltype;
                modul.choosedDiscount = modul.$route.params.choosedDiscount;
                modul.discount = modul.$route.params.data.discount_type;
                modul.data.discount_type = modul.$route.params.data.discount_type;

                modul.purcaseItems = modul.$route.params.purcaseItems;
                modul.cachedElements = modul.$route.params.cachedElements;

                // handle buyer
                const id_buyer = modul.$route.params.data.id_buyer;
                if (id_buyer) {
                    modul.getBuyerById(function (err, res) {
                        if (!err) {
                            if (res  && res.id) { // && res[0] && res[0].id
                                modul.buyer = res;
                                modul.$eventBus.$emit('globalSetBuyerSid', res.sid);
                            }
                        }
                    }, id_buyer)
                }
                // handle businesspartner
                const id_businesspartner = modul.$route.params.data.id_businesspartner;
                if (id_businesspartner) {
                    modul.getBusinessPartnerById(function (err, res) {
                        if (!err) {
                            if (res && res.id) {
                                modul.businesspartner = res;
                                modul.$eventBus.$emit('globalSetBusinessPartner', res);
                            }
                        }
                    }, id_businesspartner)
                }

//                modul.getSell(function (err, res) {
//                    if (res && res[0] && res[0].id) {
//                        // set sell data
//                        modul.data.id = res[0].id;
//                        modul.data.selltext = res[0].selltext;
//                        modul.data.selltype = res[0].selltype;
//                        modul.discount = res[0].discount_type;
//                        modul.data.discount_type = res[0].discount_type;
//                        // handle sell_element
//                        modul.getSellElementsBySellid(function (err, res) {
//                            if (res) {
//                                let purcaseItems = [];
//                                res.forEach(function (e) {
//                                    if (Number(e.pack) === 1) {
//                                        purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.price)}); // countnum vagy price
//                                    } else if (Number(e.pack) >= 2 && Number(e.pack) <= 7) {
//                                        purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.countnum)}); // countnum vagy price
//                                    }
//                                });
//                                modul.purcaseItems = purcaseItems;
//                            }
//                        }, modul.$route.params.sellId)
//
//                        // handle buyer
//                        const id_buyer = res[0].id_buyer;
//                        if (id_buyer) {
//                            modul.getBuyerById(function (err, res) {
//                                if (!err) {
//                                    if (res && res[0] && res[0].id) {
//                                        modul.buyer = res[0];
//                                        modul.$eventBus.$emit('globalSetBuyerSid', res[0].sid);
//                                    }
//                                }
//                            }, id_buyer)
//                        }
//                    }
//                }, modul.$route.params.sellId)
            } else {
                console.log("sellinone init as EMPTY");
                modul.emptyForNew();
            }
            if (localStorage.getItem("printQuestion")) {
                modul.printQuestion = ("true" === localStorage.getItem("printQuestion"));
            } else {
                modul.printQuestion = true; // for modify the default value use the settings screen too
            }
            let printQuestionExit = localStorage.getItem("printQuestionExit");
            if (printQuestionExit === null || printQuestionExit === void 0) {
                localStorage.setItem("printQuestionExit", true);
                printQuestionExit = "true";
            }
            modul.printQuestionExit = (printQuestionExit === "true");
            let printQuestionPrint = localStorage.getItem("printQuestionPrint");
            if (printQuestionPrint === null || printQuestionPrint === void 0) {
                localStorage.setItem("printQuestionPrint", true);
                printQuestionPrint = "true";
            }
            modul.printQuestionPrint = (printQuestionPrint === "true");
            let printQuestionDeliverynote = localStorage.getItem("printQuestionDeliverynote");
            if (printQuestionDeliverynote === null || printQuestionDeliverynote === void 0) {
                localStorage.setItem("printQuestionDeliverynote", false);
                printQuestionDeliverynote = "false";
            }
            modul.printQuestionDeliverynote = (printQuestionDeliverynote === "true");
            let printQuestionInvoice = localStorage.getItem("printQuestionInvoice");
            if (printQuestionInvoice === null || printQuestionInvoice === void 0) {
                localStorage.setItem("printQuestionInvoice", true);
                printQuestionInvoice = "true";
            }
            modul.printQuestionInvoice = (printQuestionInvoice === "true");

            /*
             if (localStorage.getItem("printQuestionExit")) {
             modul.printQuestionExit = ("true" === localStorage.getItem("printQuestionExit"));
             } else {
             modul.printQuestionExit = true; // for modify the default value use the settings screen too
             localStorage.setItem("printQuestionExit")
             }
             if (localStorage.getItem("printQuestionPrint")) {
             modul.printQuestionPrint = ("true" === localStorage.getItem("printQuestionPrint"));
             } else {
             modul.printQuestionPrint = true; // for modify the default value use the settings screen too
             localStorage.setItem("printQuestionPrint")
             }
             if (localStorage.getItem("printQuestionDeliverynote")) {
             modul.printQuestionDeliverynote = ("true" === localStorage.getItem("printQuestionDeliverynote"));
             } else {
             modul.printQuestionDeliverynote = true; // for modify the default value use the settings screen too
             }
             if (localStorage.getItem("printQuestionInvoice")) {
             modul.printQuestionInvoice = ("true" === localStorage.getItem("printQuestionInvoice"));
             } else {
             modul.printQuestionInvoice = false; // for modify the default value use the settings screen too
             }
             */
            if (localStorage.getItem("hasselltext")) {
                modul.hasselltext = ("true" === localStorage.getItem("hasselltext"));
            } else {
                modul.hasselltext = false; // for modify the default value use the settings screen too
            }

        },
        beforeDestroy() {
            const modul = this;
//            ipcRenderer.send('datasend', {emit: true, type: "globalPurcaseItemsExtendMoify", data: {purcaseItemsExtend: []}});
//            ipcRenderer.send('datasend', {emit: true, type: "globalBasketDataSend", data: {basketData: {discount: "", sum: "", discount_price: "",}}});
        },
        methods: {
          getElementFromCachedElementsById: function (itemKey) {
            const modul = this;
            const element = Helper.getObjectByIdFromObjectArray(modul.cachedElements, itemKey);
            return element;
          },
            makeBasketCalculation(){
                const modul = this;
                console.log("makeBasketCalculation");
                let sum = 0;
                modul.purcaseItemsExtend.forEach(function (item) {
                    sum += Number(item.itemSumPrice);

//                    let val = item.itemValue;
////                    let item = modul.getItemById(e.itemKey);
//                    if (Number(item.pack) === 1) {
//                        if (val && Number(val).toString() === val.toString()) {
//                            sum += Number(val);
//                        }
//                    } else if (Number(item.pack) >= 2 && Number(item.pack) <= 7) {
//                        if (val && Number(val).toString() === val.toString()) {
//                            sum += Number(item.default_price) * item.itemValue;
//                        }
//                    }
                });

                let sumDiscont = 0;
                const discount = modul.discount;

                sumDiscont = parseFloat(100 - Number(discount)) * parseFloat(0.01) * sum;
                sumDiscont = Helper.roundToProjectDecimal(sumDiscont);
                modul.sum = Helper.getFormattedPrice(sumDiscont);
                let discount_price = 0;
                if (discount && Number(discount).toString() === discount.toString() && discount !== 0) {
                    discount_price = Helper.roundToProjectDecimal(( Number(discount)) * parseFloat(0.01) * sum);
                }
                modul.discount_price = Helper.getFormattedPrice(discount_price);

                const basketData = {
                    discount: modul.discount,
                    sum: modul.sum,
                    discount_price: modul.discount_price,
                };
//                ipcRenderer.send('datasend', {emit: true, type: "globalPurcaseItemsExtendMoify", data: {purcaseItemsExtend: modul.purcaseItemsExtend}});
//                ipcRenderer.send('datasend', {emit: true, type: "globalBasketDataSend", data: {basketData: basketData}});
            },
//            getElementByIdSync: function (id) {
//                const modul = this;
//
//                const elements = window.db.select(
//                    function (err, res) {
//                    }
//                    , "element left join vat on vat.id=element.id_vat", "element.*, vat.vat_text, vat.cardinality", "element.id=" + Number(id) + " AND (element.`deleted` = 0 OR element.`deleted` = '0') "); // AND (`type` = 2 OR `type` = '2')
//                let element = {};
//                if (elements && elements[0] && elements[0].id) {
//                    element = elements[0];
//                }
//                return element;
//            },
            globalSetPurcaseItemsEventHandler(purcaseItems){
                this.purcaseItems = purcaseItems;
            },
            globalSetBuyerEventHandler(buyer){
                this.buyer = Object.assign({}, buyer);
            },
            globalSetBasketCalculationEventHandler(basketCalculation){
                const modul = this;
                modul.sum = basketCalculation.sum;
                modul.discount_price = basketCalculation.discount_price;
            },


            go_back: function () {
                const modul = this;

                let data = modul.makeData();
                data = Helper.filterObjectByKeys(data, ["id", "id_buyer", "id_businesspartner", "datetime", "discount_type", "sum", "selltext", "selltype", "sync_pk_adminuser", "id_adminuser", "wsid"]);
                modul.$router.push({
                    name: "sellinone", params: {data: data, purcaseItems: modul.purcaseItems, choosedDiscount:modul.choosedDiscount, cachedElements: modul.cachedElements}
                });

//                modul.$router.push({
//                    name: "sellinone", params: {
//                        sellId: modul.data.id,
//                    }
//                });
//                setTimeout(function () {
////                    SyncHandler.handle({job: 'doSell'});
//                },0);
            },
            do_finish: function () {
                const modul = this;

                const cbsave = function () {
                    const modul2 = modul;
//                    const cb = function (err, res) {
                        setTimeout(function () {
                            modul2.$router.push({
                                name: "sellinone", params: {}
                            });
                        }, 1);
                        setTimeout(function () {
//                            SyncHandler.handle({job: 'doSell'});
                        }, 1000);
//                    };
//                    window.db.update(
//                        function (err, res) {
//                            cb(err, window.db.convertResToArray(err, res))
//                        }
//                        , "sell", {'status': 1}, "id=" + modul.data.id);
                };
                if (!modul.hassaved) {
                    modul.hassaved = true;
                modul.save("finish", cbsave);
                } else {
                    cbsave()
                }
            },
            do_print: function () {
                const modul = this;
//                let sellprintInitObject = {id: res[0].id};

                const cbsave = function () {
                    const modul2 = modul;
//                    const cb = function (err, res) {
                        modul2.$router.push({
                            name: "sellprint", params: {
                                sellId: modul2.data.id,
                            }
                        });
                        setTimeout(function () {
//                            SyncHandler.handle({job: 'doSell'});
                        }, 1000);
//                    };
//                    window.db.update(
//                        function (err, res) {
//                            cb(err, window.db.convertResToArray(err, res))
//                        }
//                        , "sell", {'status': 1}, "id=" + modul.data.id);
                };
                if (!modul.hassaved) {
                    modul.hassaved = true;
                modul.save("print", cbsave);
                } else {
                    cbsave()
                }

            },
//            do_deliverynote: function () {
//                const modul = this;
//
//                const cb = function (err, res) {
////                    const modul2 = modul;
//                    const sellId = modul.data.id;
//                    if(sellId){
//                        modul.makeData0({sellId: sellId}, "deliverynote")
////                    if (extraWorkType && extraWorkType === "invoice") {
////                        modul.hassaved = true;
//////                        modul.do_giveinvoice0({sellId: sellId}, extraWorkType)
////                    }
//
//                    } else {
//                        // error.. Ilyen nincs is!
//                        // szállítót csak létező azonosítóból lehet létrehozni
//                    }
//
//
//                    setTimeout(function () {
////                        SyncHandler.handle({job: 'doSell'});
//                    }, 1000);
//
//                };
//
//                if (!modul.hassaved) {
//                    modul.hassaved = true;
//                    modul.save("deliverynote", cb)
//                } else {
//                    cb();
////                        modul.save("deliverynote")
//                }
//
////                modul.save("deliverynote", cb)
//
////                window.db.update(
////                    function (err, res) {
////                        cb(err, window.db.convertResToArray(err, res))
////                    }
////                    , "sell", {'status': 1}, "id=" + modul.data.id);
//
//            },
            makeData0: function (dataparam, extraWorkType) {
                const modul = this;
                let data = modul.makeData();
                console.log("dataparam")
                console.log(dataparam)
                data.sellId = dataparam.sellId;
                data.id = null;
                modul.getCompanyData(function (err, res) {
                    if (!err) {
                        data.companydata = res;
                        modul.makeData1(data, extraWorkType);
                    }
                });
            },
            makeData1: function (data, extraWorkType) {
                const modul = this;
              if(data.id_businesspartner){
                modul.getBusinessPartnerById(function (err, res) {
                  if (!err) {
                    data.businesspartner = res;
                    modul.makeData2(data, extraWorkType);
                  }
                }, data.id_businesspartner);

              } else {
                modul.makeData2(data, extraWorkType);
              }
            },
            makeData2: function (data, extraWorkType) {
                const modul = this;
                if(data.id_buyer){
                  modul.getBuyerById(function (err, res) { // BusinessPartnerById
                    if (!err) {
                      data.buyer = res;
                      modul.makeData3(data, extraWorkType);
                    }
                  }, data.id_buyer);
                } else {
                  modul.makeData3(data, extraWorkType);
                }
            },
            makeData3: function (data, extraWorkType) {
                const modul = this;
                if (extraWorkType && extraWorkType === "deliverynote") {
                    Helper.getDeliverynoteNextIdentifiers(function (err, res) {
                        if (!err) {
                            data.deliverynoteNextIdentifiers = res[0];
                            if (data.deliverynoteNextIdentifiers && data.deliverynoteNextIdentifiers.idkey && data.deliverynoteNextIdentifiers.idlastnumber) {
                                modul.makeData4(data, extraWorkType);
                            } else {
                                console.log("deliverynoteNextIdentifiers error-2");
                                console.log(data.deliverynoteNextIdentifiers);
                            }
                        } else {
                            console.log("deliverynoteNextIdentifiers error-1");
                            console.log(data.deliverynoteNextIdentifiers);
                        }
                    }, "deliverynote");

                } else {
                    modul.makeData4(data, extraWorkType);
                }
            },
            makeData4: function (data, extraWorkType) {
                /*
                 companydata
                 deliverynote
                 deliverynote_element

                 select companydata
                 select businesspartnerdata
                 make and fill deliverydataobject
                 insert delivery
                 foreach{
                 mAKE element data
                 insert element data
                 }
                 * */
//                console.log(data);
                const modul = this;
                let sellId = data.id;

                data.id = null;

                /*
                 Kérdés kell-e sell mentés is a szállító esetén
                 */
                data.id_buyer = data.id_buyer;
                data.id_businesspartner = data.id_businesspartner;
                data.id_adminuser = data.id_adminuser;
                data.id_sell = data.sellId; // data.id_adminuser; // TODO --- Ezt tölteni kell
                data.title = "";
                data.text = data.selltext; //"";
                data.dt = Helper.getNewUTCDateTime();
                data.dt_completion = null;
                data.dt_make = null;
                data.dt_paymentdeadline = null;
                data.from_businesspartner_syncpk = null;
                data.to_businesspartner_syncpk = data.id_businesspartner;
                data.price_sum_net = null;
                data.vat_percent = null;
                data.price_sum = data.sum;
                data.payment_type = data.selltype;

                if (data.deliverynoteNextIdentifiers) {
                    data.identifier_pre_id = data.deliverynoteNextIdentifiers['idkey'];
                    data.identifier_counter = data.deliverynoteNextIdentifiers['idlastnumber'];
                }
                if (data.companydata) {

                    data.from_businesspartnernameany = data.companydata.companynameany;
                    data.from_businesspartnername = data.companydata.companyname;
                    data.from_taxnumber = data.companydata.taxnumber;
                    data.from_taxnumbercountrygroup = data.companydata.taxnumbercountrygroup;
                    data.from_taxnumberother = data.companydata.taxnumberother;
                    data.from_registrationnumber = data.companydata.registrationnumber;
                    data.from_bank_account = data.companydata.bank_account;
                    data.from_zip = data.companydata.zip;
                    data.from_public_space = data.companydata.public_space;
                    data.from_nature_of_public_space = data.companydata.nature_of_public_space;
                    data.from_house_number = data.companydata.house_number;
                    data.from_building = data.companydata.building;
                    data.from_staircase = data.companydata.staircase;
                    data.from_floor = data.companydata.floor;
                    data.from_door = data.companydata.door;
                    data.from_county = data.companydata.county;
                    data.from_city = data.companydata.city;
                    data.from_country = data.companydata.country;
                    data.from_phone_def = data.companydata.phone_def;
                    data.from_email_def = data.companydata.email_def;
                }


                if (data.businesspartner) {
                    data.to_businesspartnernameany = data.businesspartner.businesspartnernameany;
                    data.to_businesspartnername = data.businesspartner.businesspartnername;
                    data.to_taxnumber = data.businesspartner.taxnumber;
                    data.to_taxnumbercountrygroup = data.businesspartner.taxnumbercountrygroup;
                    data.to_taxnumberother = data.businesspartner.taxnumberother;
                    data.to_registrationnumber = data.businesspartner.registrationnumber;
                    data.to_bank_account = data.businesspartner.bank_account;
                    data.to_zip = data.businesspartner.zip;
                    data.to_public_space = data.businesspartner.public_space;
                    data.to_nature_of_public_space = data.businesspartner.nature_of_public_space;
                    data.to_house_number = data.businesspartner.house_number;
                    data.to_building = data.businesspartner.building;
                    data.to_staircase = data.businesspartner.staircase;
                    data.to_floor = data.businesspartner.floor;
                    data.to_door = data.businesspartner.door;
                    data.to_county = data.businesspartner.county;
                    data.to_city = data.businesspartner.city;
                    data.to_country = data.businesspartner.country;
                    data.to_phone_def = data.businesspartner.phone_def;
                    data.to_email_def = data.businesspartner.email_def;
                }

//                console.log(data);
                if (extraWorkType && extraWorkType === "deliverynote") {
                    modul.do_deliverynote_save(data, extraWorkType)
                } else if (extraWorkType && extraWorkType === "invoice") {
                    modul.do_giveinvoice_save(data, extraWorkType) // ez nem más, mint a küldés
                } else if (extraWorkType && extraWorkType === "szamlazzhu") {
                    modul.do_sendinvoice_szamlazzhu(data, extraWorkType) // ez nem más, mint a szamlazz.hu
                }
            },
//            do_deliverynote_save: function (data, extraWorkType) {
//                const modul = this;
//
////                const cb = function (err, res) {
////                    if (!err) {
////                        Helper.stepDeliverynoteNextIdentifiers(function (err, res) {
////                            console.log(err)
////                            console.log(res)
////                            if (!err) {
////                                const deliverynoteId = window.db.lastInsertId("deliverynote");
////                                // ide kell a deliverynote_element
////                                modul.do_deliverynote_element(err, window.db.convertResToArray(err, res), {deliverynoteId: deliverynoteId, purcaseItems: modul.purcaseItems})
////                            } else {
////                                console.log(err);
////                            }
////                        }, "deliverynote")
////                    }
////                };
////                data = Helper.filterObjectByKeys(data,
////                    ["id", "id_sell", "id_buyer", "id_businesspartner", "id_adminuser", "title", "text", "dt", "dt_completion", "dt_make", "dt_paymentdeadline", "from_businesspartner_syncpk", "to_businesspartner_syncpk", "price_sum_net", "vat_percent", "price_sum", "payment_type", "identifier_pre_id", "identifier_counter", "from_businesspartnernameany", "from_businesspartnername", "from_taxnumber", "from_taxnumbercountrygroup", "from_taxnumberother", "from_registrationnumber", "from_bank_account", "from_zip", "from_public_space", "from_nature_of_public_space", "from_house_number", "from_building", "from_staircase", "from_floor", "from_door", "from_county", "from_city", "from_country", "from_phone_def", "from_email_def", "to_businesspartnernameany", "to_businesspartnername", "to_taxnumber", "to_taxnumbercountrygroup", "to_taxnumberother", "to_registrationnumber", "to_bank_account", "to_zip", "to_public_space", "to_nature_of_public_space", "to_house_number", "to_building", "to_staircase", "to_floor", "to_door", "to_county", "to_city", "to_country", "to_phone_def", "to_email_def"]
////                );
////                console.log("data_beforeInsert");
////                console.log(data);
////
////                data['sync_mdt'] = Helper.getNewUTCDateTime(); //Helper.getNewUTCDateTime();
////                data['create_dt'] = Helper.getNewUTCDateTime();
////                window.db.pinsert(
////                    function (err, res) {
////                        cb(err, window.db.convertResToArray(err, res))
////                    }
////                    , "deliverynote", data);
//
//            },
//            do_deliverynote_element: function (err, res, data) {
//                const modul = this;
//                const purcaseItems = data.purcaseItems;
//                const deliverynoteId = data.deliverynoteId;
//                let count = purcaseItems.length;
//                let actCount = 0;
//                const cbInsert = function (err, res) {
//                    actCount++;
//                    const modul2 = modul;
//                    if (count === actCount) {
//                        setTimeout(function () {
//                            const modul2 = modul;
//                            SyncHandler.handle({job: 'doSell'});
//                            modul2.$router.push({
//                                name: "sellinone", params: {}
//                            });
//                        }, 1000);
//                    }
//                };
//                Array.prototype.forEach.call(purcaseItems, function (purcaseItem) {
//                    let elementDb = {}; //Object.assign({}, purcaseItem);
//                    elementDb.id_deliverynoteId = deliverynoteId;
//                    elementDb.id_element = purcaseItem.itemKey;
//
//                    modul.getElementById(function (err, res) {
//                        if (res && res[0]) {
//
//
//                            const item = res[0]; //modul.getItemById(purcaseItem.id);
//
//                            console.log("---Ezlesszinsertálva---");
//                            console.log(elementDb);
//
////                            elementDb.id = null;
//                            elementDb.id_deliverynote = Number(elementDb.id_deliverynoteId);
//                            elementDb.id_element = Number(elementDb.id_element);
//                            elementDb.item_syncpk = item.sync_pk;
//                            elementDb.item_element_name = item.name;
//                            elementDb.item_vatpercent = item.cardinality;
//                            elementDb.item_pack = item.pack;
//                            elementDb.item_key = Number(purcaseItem.itemKey)
//                            elementDb.item_price = purcaseItem.itemPrice;
//                            elementDb.item_countnum = purcaseItem.itemCountnum;
//                            elementDb.item_sumprice = purcaseItem.itemSumPrice;
//
//                            // TODO --- ezt kell rendbe rakni, meg plusz field a default price-nak. esetéeg a VAT-nak. meg ki kell találni, hogy a sell mellett a számla külön elmentésre kerüljön, vagy ne.
//                            // Külön kéne tárolni a kezdőértéket, meg az aktuális max számlasorszámot.
//                            // kell a plusz táblák berakás a a szinkronba
//                            // kell a vat szinkron.
//                            // kell a szémla tábla, és kezelése.
//                            // kell a pdf tárolása, ha szükséges
//                            // kell a számlát tároljunk, (pdf) vagy számlaadatot.
//                            // külön legyen-e a que manager vagy hogy legyen?
//
//                            // "item_syncpk","item_element_name","item_vatpercent","item_pack","item_key","item_price"
//                            // "id_sell", "id_element", "itemprice", "deleted", "price", "countnum"
//
//                            elementDb = Helper.filterObjectByKeys(elementDb, ["id_deliverynote", "id_element", "item_syncpk", "item_element_name", "item_vatpercent", "item_pack", "item_key", "item_price", "item_countnum", "item_sumprice"]);
//                            if (!elementDb.id_element) {
////                                alert("alertéááááááááááááááááááá");
////                                confirm("confirméááááááááááááááááááá");
////                                console.log("éááááááááááááááááááá:");
////                                console.log("elementDb:");
////                                console.log(elementDb);
////                                console.log("purcaseItem:");
////                                console.log(purcaseItem);
//
//                            }
//                            elementDb['sync_mdt'] = Helper.getNewUTCDateTime(); //Helper.createDateAsUTC(new Date());
//
//                            console.log("pinsert -- deliverynote_element --- IDE KELL RAKD A BRÉKPOINTOT!")
//                            elementDb['create_dt'] = Helper.getNewUTCDateTime();
//                            window.db.pinsert(
//                                function (err, res) {
//                                    cbInsert(err, window.db.convertResToArray(err, res))
//                                }
//                                , "deliverynote_element", elementDb);
//
//                        }
//                    }, Number(purcaseItem.itemKey))
//
//
//                })
//            },
//

            do_giveinvoice: function () {
                const modul = this;
                const cbsave = function () {
                    const sellId = modul.data.id;
                    if(modul.invoiceUseType===3){
                    modul.makeData0({sellId: sellId}, "szamlazzhu")
                    } else {
                      modul.makeData0({sellId: sellId}, "invoice")

                    }
                    setTimeout(function () {
//                        SyncHandler.handle({job: 'doSell'});
                      modul.invoice_process = false;

                    }, 1000);

//                    const cb = function (err, res) {
//                        modul.makeData0({izee: "izee"}, "invoice");
//                    };
//                    window.db.update(
//                        function (err, res) {
//                            cb(err, window.db.convertResToArray(err, res))
//                        }
//                        , "sell", {'status': 1}, "id=" + modul.data.id);
                };
//                modul.save("invoice", cbsave)

              if (modul.invoice_process === false) {
                modul.invoice_process = true;
                if (!modul.hassaved) {
                  modul.hassaved = true;
                  modul.save("invoice", cbsave)
                } else {
                  cbsave()
                }
//                modul.save("invoice")
              }
            },
            do_sendinvoice_szamlazzhu: function (data,extraWorkType) {
              const modul = this;
              modul.invoice_process=true;
              const sellElements = modul.purcaseItemsExtend;
//              default adatok kikérése
              const beallitasok = HelperSzamlazzhu.getBeallitasok();
//              fejlec.szamlaszamElotag= "";
//              beallitasok.felhasznalo = "";
//              beallitasok.jelszo = "";
//              beallitasok.szamlaagentkulcs = "";
              const fejlec = HelperSzamlazzhu.getFejlec();
              beallitasok.szamlaagentkulcs = "{{szamlaagentkulcs}}";
              fejlec.szamlaszamElotag = "{{szamlaszamElotag}}";
              fejlec.keltDatum = moment().format('YYYY-MM-DD');
              fejlec.teljesitesDatum = moment().format('YYYY-MM-DD');
              const dayDelay = 4;
              fejlec.fizetesiHataridoDatum = moment().add(dayDelay, 'day').format('YYYY-MM-DD');
              let fizmod = "";
              if (Helper.Number(data.selltype) === 1) { fizmod = "készpénz" }
              if (Helper.Number(data.selltype) === 2) { fizmod = "bankkártya" }
              if (Helper.Number(data.selltype) === 3) { fizmod = "átutalás" }
              fejlec.fizmod = fizmod; // "Átutalás"//  selltype // átutalás készpénz bankkártya
              /* <!-- payment method, free text field, values ​​used on the interface are: átutalás, készpénz, bankkártya, csekk, utánvét, ajándékutalvány, barion, barter, csoportos beszedés, OTP Simple, kompenzáció, kupon, PayPal,PayU, SZÉP kártya, utalvány --> */

//fejlec.penznem= "HUF";
//fejlec.szamlaNyelve= "hu";
//fejlec.megjegyzes= "";
//fejlec.arfolyamBank= "";
//fejlec.arfolyam= "";
//fejlec.rendelesSzam= "";
//fejlec.dijbekeroSzamlaszam= "";
//fejlec.elolegszamla= "";
//fejlec.vegszamla= "";
//fejlec.helyesbitoszamla= "";
//fejlec.helyesbitettSzamlaszam= "";
              const elado = HelperSzamlazzhu.getElado();
//              elado.bank= "BB";
                elado.bankszamlaszam= "11111111-22222222-33333333";
//                elado.emailReplyto= "";
//                elado.emailTargy= "";
//                elado.emailSzoveg= "";
              const vevo = HelperSzamlazzhu.getVevo();
                vevo.nev= data.to_businesspartnername;
                vevo.irsz= data.to_zip;
                vevo.telepules= data.to_city;
                vevo.cim= data.from_nature_of_public_space+" "+data.from_house_number+" "+data.from_building+" "+data.from_staircase+" "+data.from_floor+" "+data.from_door;


                vevo.email= (data.to_email_def)?data.to_email_def:"";
//                vevo.sendEmail= (data.to_email_def)?data.to_email_def:void 0;
                vevo.sendEmail= !!(data.to_email_def);
                vevo.adoszam= data.to_taxnumber;
                vevo.postazasiNev= data.to_businesspartnername;
                vevo.postazasiIrsz= data.to_zip;
                vevo.postazasiTelepules= data.to_city;
                vevo.postazasiCim= vevo.cim;
                vevo.azonosito= "";
                vevo.telefonszam= "";
//                vevo.megjegyzes= "";
//              const fuvarlevel = HelperSzamlazzhu.getFuvarlevel();
              const fuvarlevel=void(0);
//                fuvarlevel.uticel= "";
//                fuvarlevel.futarSzolgalat= "";
//              const element = HelperSzamlazzhu.getElement();

              // Adatok beállítása
              const elements = [];
              console.log("sellElements");
              console.log(sellElements);
              data.purcaseItemsExtend = modul.purcaseItemsExtend;
             /*
             https://tudastar.szamlazz.hu/gyik/agent-brutto-netto-kerekites

             1 Vegye a számla tétel bruttó egységárát (ez lehet egész, vagy akár tört szám is).
             2 Szorozza meg a bruttó egységárat a számla tétel mennyiségével. Amennyiben az így kapott érték nem egész, kerekítse azt! Ez a számla tétel bruttó értéke.
                A számla tétel bruttó értékéből az áfakulcs segítségével kalkulálja ki a tétel áfa értékét. Ehhez használható a következő képlet: bruttó / (100 + Áfakulcs) x áfakulcs. Példa: bruttó 500 Ft-os könyvből értékesített 3 darabot, 27 százalékos áfakulccsal.
                Bruttó egységár: 500 Ft.
                Tétel mennyisége: 3 darab.
                Számla tétel bruttó érték: 500 x 3 = 1500 Ft.
                Áfakulcs: 27 százalék
              Áfa érték: 1500 / (100 + 27) x 27 = 318,89
             3 A számla tétel áfa értéke tehát 318,89, amit kerekítsen: 319 Ft.
             4 A számla tétel nettó értékét a bruttó érték (egész szám) és az áfa érték (egész szám) különbözeteként kalkulálhatja, így a nettó érték is egész szám lesz.
             */

              for (let element of sellElements) {
                const dataElement = HelperSzamlazzhu.getElement();
                const nettoegysegar = (Helper.getRoundedNumber(element.default_price, 2) / (100+Helper.getRoundedNumber(element.cardinality, 2)) ) *100;
                dataElement.megnevezes = element.name;
                dataElement.mennyiseg = element.itemCountnum;
                dataElement.mennyisegiEgyseg = HelperSzamlazzhu.getPack(element.pack, modul) // $t("selproduct.packs."
                dataElement.afakulcs = element.cardinality; // "" + (Helper.Number(element.item_vatpercent) / 100)
                dataElement.afaErtek = "" + Helper.getRoundedNumber(Helper.getRoundedNumber(element.itemSumPrice, 0) / (100+Helper.getRoundedNumber(element.cardinality, 2)) * Helper.getRoundedNumber(element.cardinality, 2) ,0);
                dataElement.bruttoErtek = "" + Helper.getRoundedNumber(Helper.Number(element.itemSumPrice), 0);
                dataElement.nettoErtek = "" + Helper.getRoundedNumber(Helper.Number(dataElement.bruttoErtek) - Helper.Number(dataElement.afaErtek), 0); // Helper.getRoundedNumber(Helper.Number(calculateHUF(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), invoiceData.exchangerate, invoiceData.currency)), 2);
                dataElement.nettoEgysegar = "" + Helper.getRoundedNumber(Helper.Number(dataElement.nettoErtek) / Helper.Number(dataElement.mennyiseg),0); // SZÁMíTANI KELL

                dataElement.megjegyzes = "";
                elements.push(dataElement);
              }
              console.log("elements");
              console.log(elements);

              // XMl kikérése
              const xml = HelperSzamlazzhu.makeXML(beallitasok, fejlec, elado, vevo, fuvarlevel, elements);
              console.log("xml");
              console.log(xml);

              // küldés a szamlazz.hu rendszerebe
              const retDoc = HelperSzamlazzhu.send(xml).then(function (res) {
                  /*
                   <?xml version="1.0" encoding="UTF-8"?>
                   <xmlszamlavalasz xmlns="http://www.szamlazz.hu/xmlszamlavalasz" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
                     <sikeres>false</sikeres>
                     <hibakod><![CDATA[260]]></hibakod>
                     <hibauzenet>
                     <![CDATA[A tétel áfa értéke nem megfelelő; áfa érték = tétel nettó értéke x áfakulcs mértéke / 100. Termék: Vágott virág (term penz).]]>
                     </hibauzenet>
                   </xmlszamlavalasz>
                   */
                if(res.result===true){
                  // sikeres számlabeküldés
                  const str=res.data;
                  const resXML=(new window.DOMParser()).parseFromString(str, "text/xml");

                  let sikeres ="";
                  let hibakod ="";
                  let hibauzenet = "";
                  try {
                    sikeres = resXML.getElementsByTagNameNS("*", "sikeres")[0].innerHTML;
                  } catch (e) {
                    console.log("ERROR - sikeres tag failed")
                  }

                  // vevoifiokurl
                  let vevoifiokurl = "";
                  try {
                    vevoifiokurl = resXML.getElementsByTagNameNS("*", "vevoifiokurl")[0].innerHTML;
                  } catch (e) {
                    console.log("ERROR - vevoifiokurl tag failed")
                  }
                  // kintlevoseg
                  let kintlevoseg = "";
                  try {
                    kintlevoseg = resXML.getElementsByTagNameNS("*", "kintlevoseg")[0].textContent;
                  } catch (e) {
                    console.log("ERROR - kintlevoseg tag failed")
                  }
                  // szamlabrutto
                  let szamlabrutto = "";
                  try {
                    szamlabrutto = resXML.getElementsByTagNameNS("*", "szamlabrutto")[0].textContent;
                  } catch (e) {
                    console.log("ERROR - szamlabrutto tag failed")
                  }
                  // szamlanetto
                  let szamlanetto = "";
                  try {
                    szamlanetto = resXML.getElementsByTagNameNS("*", "szamlanetto")[0].textContent;
                  } catch (e) {
                    console.log("ERROR - szamlanetto tag failed")
                  }
                  // szamlaszam
                  let szamlaszam = "";
                  try {
                    szamlaszam = resXML.getElementsByTagNameNS("*", "szamlaszam")[0].textContent;
                  } catch (e) {
                    console.log("ERROR - szamlaszam tag failed")
                  }
                  try {
                    hibakod = resXML.getElementsByTagNameNS("*", "hibakod")[0].textContent;
                  } catch (e) {
                    console.log("ERROR - hibakod tag failed")
                  }
                  try {
                    hibauzenet = resXML.getElementsByTagNameNS("*", "hibauzenet")[0].textContent;
                  } catch (e) {
                    console.log("ERROR - hibauzenet tag failed")
                  }
                  console.log(sikeres);
                  const alertId = Math.random();
                  if(sikeres ==="true"){ // igen
                    modul.$eventBus.$emit('globalAlert', {
                      id_delete: alertId,
                      type: "success",
                      msgPreInner: "",
                      msg: "form.succes",
                      msgPostInner: "",
                      delay: 5000
                    });
                    modul.invoice_process=false;
                  } else if(sikeres ==="false"){ // nem
                    modul.$eventBus.$emit('globalAlert', {
                      id: alertId,
                      type: "danger",
                      msgPreInner: "",
                      msg: hibauzenet,
                      msgPostInner: "",
                      delay: 10000
                    });
                    modul.invoice_process=false;
                  } else { // más, nem
                    modul.$eventBus.$emit('globalAlert', {
                      id: alertId,
                      type: "danger",
                      msgPreInner: "",
                      msg: "form.connection_error",
                      msgPostInner: "",
                      delay: 5000
                    });
                    modul.invoice_process=false;
                  }
                  console.log("Mentés");
                  try {
                    const pdfData = resXML.getElementsByTagNameNS("*", "pdf")[0].textContent; // textContent tesztelni
                    console.log("resXML");
                    console.log(resXML);
                    function b64toBlob(b64Data, contentType, sliceSize) {
                      contentType = contentType || '';
                      sliceSize = sliceSize || 512;
                      var byteCharacters = atob(b64Data);
                      var byteArrays = [];
                      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        var slice = byteCharacters.slice(offset, offset + sliceSize);
                        var byteNumbers = new Array(slice.length);
                        for (var i = 0; i < slice.length; i++) {
                          byteNumbers[i] = slice.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                      }
                      var blob = new Blob(byteArrays, {type: contentType});
                      return blob;
                    }
                    saveAs(b64toBlob(pdfData), "szla.pdf");
                  } catch (e) {
                    console.log("ERROR - pdf file failed")
                    console.log(e)
                  }
                } else {
                  // Hibás küldés
                  const alertId = Math.random();
                  modul.$eventBus.$emit('globalAlert', {
                    id: alertId,
                    type: "danger",
                    msgPreInner: "",
                    msg: "form.connection_error",
                    msgPostInner: "",
                    delay: 5000
                  });


                }
              }, function (res) {
                console.log(res);
                modul.invoice_process=false;
              });

            },
            do_newsell: function () {
                const modul = this;
                modul.$router.push({name: "sellinone"})
                setTimeout(function () {
//                    SyncHandler.handle({job: 'doSell'});
                }, 1000);
            },
            do_giveinvoice_save: function (dataparam, extraWorkType) {
                const modul = this;
                const dataObject = Object.assign({}, dataparam);
//                dataObject.machineId = machineIdSync();
                console.log(dataObject);
                dataObject.purcaseItemsExtend = modul.purcaseItemsExtend;
                dataObject.discount_price = modul.discount_price;
                dataObject.discount = modul.discount;

              const baseUrl = 'http://localhost:';
              const port = 3000;
              const postUrl = '/api/invoice/add';
              const fullPost = {invoiceData: JSON.stringify(dataObject)};

              fetch(baseUrl + port + postUrl, {
                method: 'POST', // or 'PUT'
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(fullPost),
                json: true,
              })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);
                    const body = data;


                  if (body && body.state && body.state === "received") {
//                            if (confirm(modul.$t("sell2.successDataSend"))) {
//                                modul.$router.push({name: "sellinone"})
//                            }
                  } else {
                    try {
                      const parsedBody = JSON.parse(body);
                      console.log(parsedBody);
//                                console.log("dates:");
//                                console.log(dates);
//                                resolve(dates);

                      modul.AlertInPage.msg = "sell2.alertSuccess";
                      modul.AlertInPage.type = "success";
                      setTimeout(function (e) {
                        modul.AlertInPage.msg = "";
                      }, Number(8000));

//                                if (confirm("Siker, redirect?")) {
//                                    modul2.$router.push({name: "sellinone"})
//                                }
                    } catch (e) {
                      console.log(error);

                      modul.AlertInPage.msg = "sell2.alertUnSuccess";
                      modul.AlertInPage.type = "danger";
                      setTimeout(function (e) {
                        modul.AlertInPage.msg = "";
                      }, Number(10000));

//                                if (confirm("Hiba (parse), redirect?")) {
//                                    modul2.$router.push({name: "sellinone"})
//                                }
//                            reject(error);
                    }
                  }

                })
                .catch((error) => {
                  console.error('Error:', error);

                  console.log(error);
                  modul.AlertInPage.msg = "sell2.alertUnSuccessHttp";
                  modul.AlertInPage.type = "danger";
                  setTimeout(function (e) {
                    modul.AlertInPage.msg = "";
                  }, Number(10000));

                });




//                const baseUrl = 'http://localhost:';
//                const port = 3000;
//                const postUrl = '/api/invoice/add';
//                const fullPost = {invoiceData: JSON.stringify(dataObject)};
//                request.post({
//                    url: baseUrl + port + postUrl,
//                    form: fullPost,
//                    headers: {
//                        "cache-control": "no-cache",
//                        "content-type": "application/json",
//                        "Access-Control-Allow-Origin": "*",
//                    },
//                    json: true,
//                }, function (error, response, body) {
//                    const res = {error: error, response: response, body: body};
//                    const modul2 = modul;
//                    if (response && response.statusCode && response.statusCode === 200) {
//                        console.log("res:");
//                        console.log(res);
//                        console.log("dddddddddddddddddd");
//                        console.log(body);
//
//                        if (body && body.state && body.state === "received") {
////                            if (confirm(modul.$t("sell2.successDataSend"))) {
////                                modul.$router.push({name: "sellinone"})
////                            }
//                        } else {
//                            try {
//                                const parsedBody = JSON.parse(body);
//                                console.log(parsedBody);
////                                console.log("dates:");
////                                console.log(dates);
////                                resolve(dates);
//
//                                modul.AlertInPage.msg = "sell2.alertSuccess";
//                                modul.AlertInPage.type = "success";
//                                setTimeout(function (e) {
//                                    modul.AlertInPage.msg = "";
//                                }, Number(8000));
//
////                                if (confirm("Siker, redirect?")) {
////                                    modul2.$router.push({name: "sellinone"})
////                                }
//                            } catch (e) {
//                                console.log(error);
//
//                                modul.AlertInPage.msg = "sell2.alertUnSuccess";
//                                modul.AlertInPage.type = "danger";
//                                setTimeout(function (e) {
//                                    modul.AlertInPage.msg = "";
//                                }, Number(10000));
//
////                                if (confirm("Hiba (parse), redirect?")) {
////                                    modul2.$router.push({name: "sellinone"})
////                                }
////                            reject(error);
//                            }
//                        }
//
//                    } else if (response && response.statusCode && response.statusCode >= 400) {
//                        console.log(error);
//                        modul.AlertInPage.msg = "sell2.alertUnSuccessHttpCode";
//                        modul.AlertInPage.msgPost = "(" + response.statusCode + ")";
//                        modul.AlertInPage.type = "danger";
//                        setTimeout(function (e) {
//                            modul.AlertInPage.msg = "";
//                            modul.AlertInPage.msgPost = "";
//                        }, Number(10000));
//
////                        if (confirm("Hiba (status), redirect?")) {
////                            modul2.$router.push({name: "sellinone"})
////
////                        }
////                        reject(response);
//                    }
//                    if (error) {
//                        console.log(error);
//
//                        modul.AlertInPage.msg = "sell2.alertUnSuccessHttp";
//                        modul.AlertInPage.type = "danger";
//                        setTimeout(function (e) {
//                            modul.AlertInPage.msg = "";
//                        }, Number(10000));
//
////                        if (confirm("Hiba (http), redirect?")) {
////                            modul2.$router.push({name: "sellinone"})
////
////                        }
////                        reject(error);
//                    }
//                })
//                    .than(function (r) {
//                    console.log("r:");
//                    console.log(r);
//                })


            },
//            do_giveinvoice0: function (dataparam) {
//                const modul = this;
//                let data = modul.makeData();
//                data.sellId = dataparam.sellId;
//                data.id = null;
//
//                // TODO -- ....
//            },

            makeData(){
                const modul = this;


                let data = {};
                data.id = null;
                if (modul.data.id) {
                    data.id = modul.data.id;
                }
                if (window && window.user && window.user.id) {
                    data.id_adminuser = window.user.id;
                }
                if (window && window.user && window.user.sync_pk) {
                    data.sync_pk_adminuser = window.user.sync_pk;
                }
                data.id_buyer = null;
                data.id_businesspartner = null;
                if (modul.buyer.id) {
                    data.id_buyer = modul.buyer.id;
                }
                if (modul.businesspartner.id) {
                    console.log(modul.businesspartner)
                    data.id_businesspartner = modul.businesspartner.id;
                }
//                data.discount_type = null;
//                if (typeof modul.buyer.discount !== "undefined") {
//                    data.discount_type = modul.buyer.discount;
//                } else if (modul.calculateDiscount(modul.sum)) {
                data.discount_type = modul.calculateDiscount(modul.sum);
//                }
                data.sum = modul.sum;
                data.selltext = modul.data.selltext;
                data.selltype = modul.data.selltype;
//                data.wsid = machineIdSync();
                data['datetime'] = Helper.getNewUTCDateTime(); //new Date();
                data['sync_mdt'] = Helper.getNewUTCDateTime(); // Helper.createDateAsUTC(new Date());
//                data = Helper.filterObjectByKeys(data, ["id", "id_buyer", "id_businesspartner", "datetime", "discount_type", "sum", "selltext", "selltype", "sync_pk_adminuser", "id_adminuser", "wsid"]);

                return data;

            },
            calculateDiscount: function () {
                const modul = this;
                let actualDiscount = 0; //modul.discount; // modul.data.discount_type
                if (modul.data && modul.data.discount_type && !isNaN(Number(modul.data.discount_type))) {
                    actualDiscount = Number(modul.data.discount_type);
                }
                if (modul.choosedDiscount && !isNaN(Number(modul.choosedDiscount))) { // &&Number(modul.choosedDiscount>actualDiscount)
                    actualDiscount = Number(modul.choosedDiscount);
                }
                let buyerDiscount = 0;
                if (typeof modul.buyer.discount !== "undefined") {
                    buyerDiscount = Number(modul.buyer.discount);
                }
                if (Number(buyerDiscount) >= Number(actualDiscount)) {
                    actualDiscount = buyerDiscount;
                }
                let businesspartnerDiscount = 0;
                if (typeof modul.businesspartner.discount !== "undefined") {
                    businesspartnerDiscount = Number(modul.businesspartner.discount);
                }
                if (Number(businesspartnerDiscount) >= Number(actualDiscount)) {
                    actualDiscount = businesspartnerDiscount;
                }
                return actualDiscount;
            },

//            calculateDiscount: function () {
//                const modul = this;
//                let actualDiscount = modul.discount; // modul.data.discount_type
//                if (modul.choosedDiscount !== void(0) && modul.choosedDiscount !== null) { // &&Number(modul.choosedDiscount>actualDiscount)
//                    actualDiscount = modul.choosedDiscount;
//                }
//                let buyerDiscount = 0;
//                if (typeof modul.buyer.discount !== "undefined") {
//                    buyerDiscount = Number(modul.buyer.discount);
//                }
//                let businesspartnerDiscount = 0;
//                if (typeof modul.businesspartner.discount !== "undefined") {
//                    businesspartnerDiscount = Number(modul.businesspartner.discount);
//                }
//                if (actualDiscount === void(0) || actualDiscount === null) {
//                    actualDiscount = 0;
//                }
//                if (Number(buyerDiscount) >= Number(actualDiscount)) {
//                    actualDiscount = buyerDiscount;
//                }
//                if (Number(businesspartnerDiscount) >= Number(actualDiscount)) {
//                    actualDiscount = businesspartnerDiscount;
//                }
//                return actualDiscount;
//            },
            save(extraWorkType, cbsave){
                const modul = this;
                let data = modul.makeData();
                data = Helper.filterObjectByKeys(data, ["id", "id_buyer", "id_businesspartner", "datetime", "discount_type", "sum", "selltext", "selltype", "sync_pk_adminuser", "id_adminuser", "wsid"]);
//                let sellId = data.id;

                data['status'] = 1;
                data['sync_mdt'] = Helper.getNewUTCDateTime(); //Helper.getNewUTCDateTime();

              // data összerakása

              const elements=[];
              Array.prototype.forEach.call(modul.purcaseItemsExtend, function (purcaseItem) {
                const dataElement = {};
                if (Number(purcaseItem.pack) === Number(1)) {
                  dataElement.id_element = purcaseItem.itemKey;
                  dataElement.itemprice = purcaseItem.itemPrice;
                  dataElement.price = purcaseItem.itemSumPrice;
                  dataElement.countnum = purcaseItem.itemCountnum;
                }
                if (Number(purcaseItem.pack) >= 2 && Number(purcaseItem.pack) <= 7) {
                  dataElement.id_element = purcaseItem.itemKey;
                  dataElement.itemprice = purcaseItem.itemPrice;
                  dataElement.price = purcaseItem.itemSumPrice;
                  dataElement.countnum = purcaseItem.itemValue;
                }
                dataElement.deleted=0;
                elements.push( dataElement);
              });
              data['elements'] = elements;


              Api.addSell({data:data}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
//                  {"result":true,"data":{"id":"135677"}}
                  modul.data.id = e.data.id;
                  if (typeof cbsave === "function") {
                    cbsave()
                  }
//                  cb(null, e.data);
                }
              }, function (err) {
                console.log(err)
                if (typeof cbsave === "function") {
                    modul.hassaved=false;
                  cbsave()
                }
//                cb(err, null);
              });

            },


            emptyForNew(){
                const modul = this;
                this.data = Object.assign({}, modul.dataBase);
                this.stock = {};
                modul.hassaved = false;
                this.$router.push({name: "sellinone"})
            },
//            /**
//             * Ha vissza-val jövünk szerkesztésre
//             * @param cb
//             * @param id_sell
//             */
//            getSellElementsBySellid: function (cb, id_sell) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell_element left join element on element.id = sell_element.id_element", "*", "id_sell=" + id_sell); // left join element on element.id = sell_element.id_element  -- , element.id id
//            },
            getElementById: function (cb, id) {
                const model = this;
              Api.getElement({id:id}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null, e.data);
                }
              }, function (err) {
                console.log(err)
                cb(err, null);
              });
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        cb(err, arrRes)
//                    }
//                    , "element left join vat on element.vat_syncpk=vat.sync_pk", "element.*, vat.cardinality as cardinality", "(element.id=" + id + " OR element.id=" + Number(id) + ") AND (`element`.`deleted` = 0 OR `element`.`deleted` = '0')"); //  AND type = 2
////                    , "element", "*", "id=" + Number(id) + " OR id=" + window.db.quote(id) + " AND (`deleted` = 0 OR `deleted` = '0')"); //  AND type = 2

            },
            getBusinessPartnerById: function (cb, id) {
              Api.getBusinessPartner(id).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null, e.data);
                }
              }, function (err) {
                console.log(err)
                cb(err, null);
              });

//              window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "businesspartner", "*", "(id=" + id + " OR id=" + Number(id) + ") AND (`deleted` = 0 OR `deleted` = '0')");
            },

//            getElementByIdSync: function (id) {
//                const modul = this;
//                const elements = window.db.select(
//                    function (err, res) {
//                    }
//                    , "element", "*", "(id=" + id + " OR id=" + Number(id) + ") AND (`deleted` = 0 OR `deleted` = '0') "); // AND (`type` = 2 OR `type` = '2')
//                let element = {};
//                if (elements && elements[0] && elements[0].id) {
//                    element = elements[0];
//                }
//                return element;
//            },

            getBuyerById: function (cb, id) {
              Api.getBuyer({id:id}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null, e.data);
                }
              }, function (err) {
                console.log(err)
                cb(err, null);
              });

//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "buyer", "*", "(id=" + id + " OR id=" + Number(id) + ") AND (`deleted` = 0 OR `deleted` = '0')");
            },
            getCompanyData: function (cb) {
              Api.getCompanyData(id).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null, e.data);
                }
              }, function (err) {
                console.log(err)
                cb(err, null);
              });

//              window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "companydata", "*"); // , "(`deleted` = 0 OR `deleted` = '0')"
            },
        },
        components: {
            LinkToTemplate,
            InputText,
            SellHeader,
            AlertInPage,
            BarcodeGenerator,
            BuyerSearcher,
            ProductSearcher,
            ProductTabs,
            BasketDisplayer
        },
    };
</script>


<style>

    .sellinone .searchResultContainer {
        position: relative;
        top: 0;
        left: 0;
    }

    .sellinone .searchResult {
        position: relative;
        background-color: white;
        width: 100%;
        z-index: 5;
        left: 0;
        top: 0;
        margin-bottom: 15px;
    }

    .sellinone .scrollHeightEnable600 {
        overflow: auto;
        max-height: 600px;
    }

    /*.sellinone .discount_type {*/
    /*width: 16px;*/
    /*}*/

    .sellinone label.sum {
        color: red;
        font-size: 2rem;
    }

    .sellinone .customPaddingTop {
        padding-top: 1px;
    }

    .sellinone .sell .discount_type_container {
        /*font-size: 1rem;*/
        padding: 0.1rem .55rem;
        color: blue;
    }

    .sellinone .sell .sid2_keyboard {
        width: 1px;
        max-width: 1px;
        border-width: 0;
    }

    .sellinone .dataTables_filter {
        display: none;
    }

    .sellinone .sid.is-invalid {
        background-color: #f1b0b7;
    }

    /* ------------- */
    .sellinone .elementContainer {
        display: block;
        text-align: justify;
        margin: -3px -3px 3px -3px;
    }

    .receiptDisplayContainer .icons {
        width: 1%;
    }

    /*.sellinone .elementContainer:after {*/
    /*content: '';*/
    /*display: block;*/
    /*clear: both;*/
    /*}*/
    /*.sellinone .box{*/
    /*!*display:inline-block;*!*/
    /*!*display:grid;*!*/
    /*border:1px solid grey;*/
    /*float: left;*/
    /*text-align:center;*/
    /*}*/

    /*.sellinone .box:before {*/
    /*content: "";*/
    /*display: inline-block;*/
    /*vertical-align: middle;*/
    /*height: 0;*/
    /*}*/
    /*!*.box.box-50{*!*/
    /*!*width: 50px;*!*/
    /*!*height: 50px;*!*/
    /*!*}*!*/
    /*!*.box.box-100-50{*!*/
    /*!*width: 100px;*!*/
    /*!*height: 50px;*!*/
    /*!*}*!*/
    /*.sellinone .box.box-x{*/
    /*min-width: 100px;*/
    /*height: 3.3em;*/
    /*!*max-width: 135px;*!*/
    /*margin:3px;*/
    /*!*padding: 0 3px;*!*/
    /*overflow: hidden;*/
    /*border-radius: 4px;*/
    /*!*border-color: #888;*!*/
    /*border-top: 4px solid rgb(33, 37, 41);*/
    /*text-align: left;*/
    /*}*/
    /*.sellinone .btn-box{*/
    /*position: relative;*/
    /*top: 0;*/
    /*left: 0;*/
    /*cursor: pointer;*/
    /*}*/

    /*.sellinone .btn-box label{ display: block;*/
    /*!*width: 100%;*!*/
    /*!*height: 100%;*!*/
    /*margin: 0;*/
    /*!*padding: 0;*!*/
    /*!*position: absolute;*!*/
    /*!*top: 0;*!*/
    /*!*left: 0;*!*/
    /*cursor: pointer;*/
    /*}*/

    @page {
        margin-left: 25px;
        margin-right: 15px;
    }

    .categorybutton {
        display: inline-block;
        margin-right: 5px;
    }


</style>
